import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-24 md:py-32 bg-dark-900 relative" data-id="element-83">
      <div className="container mx-auto px-6" data-id="element-84">
        <div className="max-w-4xl mx-auto" data-id="element-85">
          <motion.div className="grid md:grid-cols-2 gap-12 items-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-86">
            <div data-id="element-87">
              <h2 className="text-5xl md:text-6xl leading-[0.9] mb-6" data-id="element-88">
                SOBREVIVIENDO A LA ERA DE LAS{' '}
                <span className="text-brand-muted" data-id="element-89">
                  RELACIONES DESECHABLES.
                </span>
              </h2>
            </div>
            <div className="relative" data-id="element-90">
              {/* Decorative line */}
              <div className="hidden md:block absolute -left-6 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-dark-600 to-transparent" data-id="element-91"></div>

              <p className="text-lg text-brand-muted leading-relaxed font-light" data-id="element-92">
                Vivimos en la era del Amor Líquido, donde los vínculos son
                frágiles y el ghosting se ha normalizado. Si te encuentras
                releyendo conversaciones de madrugada buscando señales que no
                están ahí, es momento de recuperar el control para poder ganar
                la partida.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}